import React, { useState, useEffect, useContext } from 'react'
import './styles.scss'
import { useLocation, useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { InputText } from 'primereact/inputtext'
import { Dropdown } from 'primereact/dropdown'
import { FloatLabel } from 'primereact/floatlabel'
import { getLocalUserDetails } from 'Utils/LocalStorage_Handler'
import { ROUTE_STRINGS } from 'Utils/Constants'
import apiAdapterCoffeeWeb from 'Services/apiAdapter_CoffeeWeb'
import ErrorMessageModal from 'Components/UIComponent/ConfirmationModal'
import Button from 'Components/UIComponent/Button'
import { CoffeeWebContext } from 'Context/CoffeeWebContext'
import useAnalytics from 'Utils/useAnalytics'
import { USER_EVENTS } from 'Utils/Constants/analyticsEvents'
import razorpay from './PaymentServices/razorpay'
import paypal from './PaymentServices/paypal'
import stripe from './PaymentServices/stripe'

const PaymentGateway = ({ showSuccess, showError, mockAccordingSymbol, mockSubPaymentMapping, mockSelectedSubscriptionDetails, mockTesting, mockUserDetails }) => {
  const userDetails = getLocalUserDetails()
  const location = useLocation()
  const history = useHistory()
  const { t } = useTranslation()
  const { setLoading, setIsCustomLoading } = useContext(CoffeeWebContext)
  const { trackEvent } = useAnalytics()

  const params = new URLSearchParams(location.search)
  const selectedSubscriptionId = params.get('id')
  const { state: selectedSubscription } = location
  const [subPaymentMapping, setSubPaymentMapping] = useState([])
  const [selectedSubscriptionDetailes, setSelectedSubscriptionDetailes] = useState({})
  const [stateList, setStateList] = useState([])
  const [userSelectedState, setUserSelectedState] = useState(userDetails.idState)
  const [billingInformation, setBillingInformation] = useState()
  const [selectedState, setSelectedState] = useState({})
  const [userStateId, setUserStateId] = useState({})
  const [accordingSymbol, setAcoordingSymbol] = useState(true)
  const [gstInput, setgstInput] = useState({
    gstNumber: '',
    organistationName: '',
    organistationAddress: '',
    selectedState: '',
    email: userDetails?.email,
    userName: `${userDetails.firstName} ${userDetails.lastName}`
  })

  const subscriptionColorConst = [
    {
      id: '0',
      color: '#cbcccd, #e5e8eb, #cbcccd'
    },
    {
      id: '1',
      color: '#50b3f6, #8DD5F4, #50b3f6'
    },
    {
      id: '2',
      color: '#a48011, #e7cd77, #a48011'
    },
    {
      id: '3',
      color: '#8A8A8A, #D4D4D4, #8A8A8A'
    }
  ]

  // testing purpose

  useEffect(() => {
    if (mockTesting) {
      setAcoordingSymbol(mockAccordingSymbol)
      setSelectedSubscriptionDetailes(mockSelectedSubscriptionDetails)
      setSubPaymentMapping(mockSubPaymentMapping)
    }
  }, [])

  useEffect(() => {
    GetSubscriptionTypes()
    getGstDetails()
    getStateList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    fetchUserStateData()
  }, [stateList])

  const GetSubscriptionTypes = async () => {
    setLoading(true)
    try {
      const response = await apiAdapterCoffeeWeb.getAllSubscriptionPaymentMappingById({
        id: selectedSubscriptionId,
        userId: userDetails.id
      })

      setSubPaymentMapping(response.data?.returnLst)

      setSelectedSubscriptionDetailes(response.data?.returnLst[0])
    } catch (error) {
      showError({
        title: t('ERROR_TITLE'),
        message: `<p>${t('WE_ARE_UNABLE_TO_PROCEED_WITH_THE_SELECTED_PLAN')}</p><p>${t('PLEASE_TRY_AGAIN_OR_CHOOSE_ANOTHER_ONE')}</p><p>${t('CONTACT_SUPPORT_TEAM')}</p>`,
        buttonLabel: t('OK'),
        onConfirm: () => {
          history.push({ pathname: ROUTE_STRINGS.subscription })
        },
        onCancel: () => {
          history.push({ pathname: ROUTE_STRINGS.subscription })
        }
      })
    } finally {
      setLoading(false)
    }
  }

  const getStateList = async () => {
    try {
      const response = await apiAdapterCoffeeWeb.getStateList(userDetails.countryId)

      if (response.status === 200) {
        setStateList(response.data)
      }
    } catch (error) {
      // errorHandler
    }
  }

  const selectPaymentBtn = (ele) => {
    const razorPaymentInstance = razorpay({ gstInput, setLoading, showError, setIsCustomLoading, trackEvent })
    const paypalPaymentInstances = paypal({ setLoading, showError, trackEvent })
    const stripeInstances = stripe({ setLoading, showError, trackEvent })

    console.log('payment-clicked')

    if (ele?.paymentName === 'RazorPay') {
      trackEvent(USER_EVENTS.PAYMENT_INITIATED_RAZORPAY) // user-analytics
      razorPaymentInstance.razorpayCreateOrder(ele, billingInformation)
    }

    if (ele.paymentName === 'PayPal') {
      paypalPaymentInstances.paypalCreateOrder(ele)
    }

    if (ele.paymentName === 'Stripe') {
      stripeInstances.stripeCreateOrder(ele)
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target

    setgstInput((prevState) => ({
      ...prevState,
      [name]: value
    }))
  }

  const postGstDetailes = async () => {
    const { userName, organistationName, organistationAddress, gstNumber, email } = gstInput
    const { id: userId, firstName } = userDetails
    const getOrDefault = (value, defaultValue) => value || defaultValue

    const gstData = {
      idUserGstdetails: 0,
      userId,
      userName: getOrDefault(userName, firstName),
      organistationName,
      organistationAddress,
      stateId: selectedState ? selectedState.idState : 0,
      gstno: getOrDefault(gstNumber, 'NA'),
      entryDate: new Date().toISOString(),
      lastUsed: true,
      lastUsedDtm: new Date().toISOString(),
      email: getOrDefault(email, userDetails.email)
    }

    await apiAdapterCoffeeWeb
      .postUserGSTDetail(gstData)
      .then(() => {
        showSuccess({
          title: t('SUCCESS'),
          message: t('UPDATED_SUCCESSFULLY'),
          buttonLabel: t('OK')
        })

        getGstDetails()
      })
      .catch(() => {
        showError({
          title: t('ERROR_TITLE'),
          message: t('UPDATE_FAILED'),
          buttonLabel: t('OK')
        })
      })
  }

  const getGstDetails = async () => {
    try {
      const response = await apiAdapterCoffeeWeb.getUserGSTDetailByList(userDetails.id)

      if (response.status === 200) {
        setAcoordingSymbol(true)
        const userActiveData = response.data?.returnLst.filter((item) => item.lastUsed === true)

        setBillingInformation(userActiveData[0])

        setgstInput({
          ...gstInput,
          organistationAddress: userActiveData[0]?.organistationAddress,
          organistationName: userActiveData[0]?.organistationName,
          gstNumber: userActiveData[0]?.gstno,
          userName: userActiveData[0]?.userName === '' ? userDetails.firstName : userActiveData[0]?.userName,
          email: userActiveData[0]?.email === '' ? userDetails.email : userActiveData[0]?.email
        })

        setUserStateId(userActiveData[0]?.stateId)
        setUserSelectedState(userActiveData[0]?.stateId)
      }
    } catch (error) {
      // errorHandler
    }
  }

  const fetchUserStateData = () => {
    if (stateList) {
      const userState = stateList.find((ele) => ele.idState === userStateId)

      setSelectedState(userState)
      handleStateSelection(null, userState)
    }
  }

  const handleStateSelection = (event, userState) => {
    const value = event ? event.target.value : userState

    setSelectedState(value)
    if (value) {
      setUserSelectedState(value)
    }
  }

  const ITEM_HEIGHT = 48
  const ITEM_PADDING_TOP = 2

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250
      }
    }
  }

  const selectedColor = subscriptionColorConst.filter(({ id }) => id === selectedSubscriptionId).map(({ color }) => color)
  const neutralColor = selectedColor.length ? selectedColor.toString().slice(0, 7) : subscriptionColorConst[0].color

  const subscriptionColor = selectedSubscription ? selectedSubscription.subscriptionColor.slice(0, 7) : neutralColor.slice(0, 7)

  return (
    <>
      {subPaymentMapping.length > 0 && (
        <div className="payment-container" data-testid="payment-container">
          <div className="container payment-method" data-testid="payment-method">
            <div
              className="card v-100 shadow card1 payment-card"
              style={{
                boxShadow: `0px 0px 10px ${subscriptionColor}`,
                border: `1px solid ${subscriptionColor}`
              }}
            >
              <div className="order-container" style={{ backgroundColor: ` ${subscriptionColor}` }} data-testid="order-container">
                <h4 className="order-summary" data-testid="order-summary">
                  {t('ORDER_SUMMARY')}
                </h4>
              </div>
              <div className="subscription-conatiner" data-testid="subscription-container">
                <div className="subscription-name" data-testid="subscription-name">
                  {selectedSubscriptionDetailes?.name}
                </div>
                <div className="subscription-country" data-testid="subscription-country">
                  {userDetails.countryId === 102 ? `${selectedSubscriptionDetailes?.currencyType}` : '$'}
                </div>
                <div className="subscription-baseprice" data-testid="subscription-base-price">
                  {userDetails.countryId === 102 ? `${selectedSubscriptionDetailes?.basePrice}` : `${selectedSubscriptionDetailes?.amountInDollars}.00`}
                </div>
              </div>
              {userDetails.countryId === 102 && (
                <>
                  {userSelectedState === 17 ? (
                    <>
                      {selectedSubscriptionDetailes?.discountedamount > 0 && (
                        <>
                          <div className="subscription-conatiner" data-testid="subscription-details-container">
                            <div className="discount-amount">{t('DISCOUNTED_AMOUNT')}</div>
                            <div data-testid="subscription-details-currency-type">{selectedSubscriptionDetailes?.currencyType}</div>
                            <div className="discount-currency" data-testid="discounted-amount">
                              {selectedSubscriptionDetailes?.discountedamount}
                            </div>
                          </div>
                          <div className="subscription-conatiner">
                            <div className="actual-amount" data-testid="actual-amount">
                              {t('ACTUAL_AMOUNT')} {selectedSubscriptionDetailes?.name}
                            </div>
                            <div className="actual-amount" data-testid="currency-type">
                              {selectedSubscriptionDetailes?.currencyType}
                            </div>
                            <div className="actual-currency" data-testid="actual-currency">
                              {selectedSubscriptionDetailes?.actualAmount}
                            </div>
                          </div>
                        </>
                      )}
                      <div className="subscription-conatiner">
                        <div className="cgst" data-testid="cgst-fees">
                          {t('CGST_AND_FEES')}({selectedSubscriptionDetailes?.cgst}%)
                        </div>
                        <div className="cgst-currencytype" data-testid="subscription-details-cgst-currency-type">
                          {selectedSubscriptionDetailes?.currencyType}
                        </div>
                        <div className="cgst-amount" data-testid="cgst-amount">
                          {selectedSubscriptionDetailes?.cgstAmount}
                        </div>
                      </div>
                      <div className="subscription-conatiner">
                        <div className="sgst" data-testid="sgst-fees">
                          {t('SGST_AND_FEES')}({selectedSubscriptionDetailes?.sgst}%)
                        </div>
                        <div className="sgst-currency" data-testid="subscription-details-sgst-currency">
                          {selectedSubscriptionDetailes?.currencyType}
                        </div>
                        <div className="sgst-amount" data-testid="subscription-details-sgst-amount">
                          {selectedSubscriptionDetailes?.sgstAmount}
                        </div>
                      </div>
                      {selectedSubscriptionDetailes?.roundoftonearby > 0 && (
                        <div className="subscription-conatiner">
                          <div className="round-to-nearby">Round of to nearby</div>
                          <div className="round-to-nearby-currency" data-testid="round-to-nearby-currency">
                            {selectedSubscriptionDetailes?.currencyType}
                          </div>
                          <div className="round-to-nearby-details" data-testid="round-to-nearby-details">
                            {selectedSubscriptionDetailes?.roundoftonearby}
                          </div>
                        </div>
                      )}
                    </>
                  ) : (
                    <>
                      <div className="subscription-conatiner">
                        <div className="igst">
                          {t('IGST_AND_FEES')}({selectedSubscriptionDetailes?.igst}%)
                        </div>
                        <div className="igst-currencytype">{selectedSubscriptionDetailes?.currencyType}</div>
                        <div className="igst-amount">{selectedSubscriptionDetailes?.igstAmount}</div>
                      </div>
                      {selectedSubscriptionDetailes?.roundoftonearby > 0 && (
                        <div className="subscription-conatiner">
                          <div className="round-to-nearby">{t('ROUND_OF_TO_NEARBY')}</div>
                          <div className="round-to-nearby-currency">{selectedSubscriptionDetailes?.currencyType}</div>
                          <div className="round-to-nearby-details">{selectedSubscriptionDetailes?.roundoftonearby}</div>
                        </div>
                      )}
                    </>
                  )}
                </>
              )}

              <hr></hr>
              {userDetails.countryId === 102 && (
                <>
                  {userSelectedState === 17 ? (
                    <div className="subscription-conatiner" style={{ margin: '0px 0px 10px' }}>
                      <div className="total">{t('TOTAL')}</div>
                      <div className="total-currency" data-testid="total-currency">
                        {userDetails.countryId === 102 ? `${selectedSubscriptionDetailes?.currencyType}` : '$'}
                      </div>
                      <div className="cgst-tax" data-testid="cgst-tax">
                        {userDetails.countryId === 102 ? `${selectedSubscriptionDetailes?.csgstTaxableAmount}` : `${selectedSubscriptionDetailes?.amountInDollars}.00`}
                      </div>
                    </div>
                  ) : (
                    <div className="subscription-conatiner" style={{ margin: '0px 0px 10px' }}>
                      <div className="total">{t('TOTAL')}</div>
                      <div className="total-currency">{userDetails.countryId === 102 ? `${selectedSubscriptionDetailes?.currencyType}` : '$'}</div>
                      <div className="cgst-tax">{userDetails.countryId === 102 ? `${selectedSubscriptionDetailes?.igstTaxableAmount}` : `${selectedSubscriptionDetailes?.amountInDollars}.00`}</div>
                    </div>
                  )}
                </>
              )}
              {userDetails.countryId !== 102 && (
                <>
                  <div className="subscription-conatiner" style={{ margin: '0px 0px 10px' }}>
                    <div className="total">{t('TOTAL')}</div>
                    <div className="total-currencytype">{userDetails.countryId === 102 ? `${selectedSubscriptionDetailes?.currencyType}` : '$'}</div>
                    <div className="igst-amount">{userDetails.countryId === 102 ? `${selectedSubscriptionDetailes?.igstTaxableAmount}` : `${selectedSubscriptionDetailes?.amountInDollars}.00`}</div>
                  </div>
                </>
              )}
            </div>

            <div
              className="payment-card"
              style={{
                border: `1px solid ${subscriptionColor}`
              }}
              data-testid="payment-card"
            >
              <div
                className="payment-method-container"
                style={{
                  backgroundColor: ` ${subscriptionColor}`
                }}
                data-testid="payment-method-container"
              >
                <h4 className="payment-method-heading">{t('PAYMENT_METHOD')}</h4>
              </div>
              <div className="no-payment" data-testid="no-payment-method-available">
                <>
                  {subPaymentMapping.length === 0 ? (
                    <h4 className="no-payment-available">{t('NO_PAYMENT_METHOD_AVAILABLE')}</h4>
                  ) : (
                    subPaymentMapping.map((ele, index) => (
                      <div key={index} className="paypal-payment-btn" onClick={() => selectPaymentBtn(ele)}>
                        <img alt="" src={ele.imageUrl} />
                      </div>
                    ))
                  )}
                </>
              </div>
            </div>
          </div>

          <div className="container payment-method-gst">
            <div className="payment-card-gst">
              <div className="billingInfo-card-gst " style={{ boxShadow: `0px 0px 10px ${subscriptionColor}`, border: `1px solid ${subscriptionColor}` }}>
                <div
                  className="gst-header-card"
                  style={{
                    backgroundColor: ` ${subscriptionColor}`
                  }}
                >
                  <div className="billing-text">{t('BILLING_INFORMATION')}</div>
                  <div className="according-symbol" data-testid=" ">
                    {accordingSymbol === true ? <i className="pi pi-pencil" onClick={() => setAcoordingSymbol(false)} /> : <i className="pi pi-pen-to-square" onClick={() => setAcoordingSymbol(true)} />}
                  </div>
                </div>

                {accordingSymbol && (
                  <div className="card shadow m-1" style={{ padding: '15px' }}>
                    {gstInput.userName}
                  </div>
                )}

                {!accordingSymbol && (
                  <div className="text-field" data-testid="text-field">
                    <div className="input-field">
                      <FloatLabel>
                        <InputText id="userName" name="userName" value={gstInput?.userName} onChange={handleChange} className="p-inputtext-sm" autoComplete="off" data-testid="name-input-field" />
                        <label htmlFor="userName" data-testid="name-label" className="input-field-label">
                          {t('NAME')}
                        </label>
                      </FloatLabel>
                    </div>

                    <div className="input-field">
                      <FloatLabel>
                        <InputText id="organistationName" name="organistationName" value={gstInput?.organistationName} onChange={handleChange} className="p-inputtext-sm" autoComplete="off" data-testid="organization-name" />
                        <label htmlFor="organistationName" data-testid="organization-label" className="input-field-label">
                          {t('ORGANIZATION_NAME')}
                        </label>
                      </FloatLabel>
                    </div>

                    <div className="input-field">
                      <FloatLabel>
                        <InputText id="organistationAddress" name="organistationAddress" value={gstInput?.organistationAddress} onChange={handleChange} className="p-inputtext-sm" autoComplete="off" data-testid="organization-address" />
                        <label htmlFor="organistationAddress" className="input-field-label" data-testid="organization-address-label">
                          {t('BILLING_ADDRESS')}
                        </label>
                      </FloatLabel>
                    </div>

                    <div className="input-field">
                      <FloatLabel>
                        <InputText id="email" name="email" value={gstInput?.email} onChange={handleChange} className="p-inputtext-sm" autoComplete="off" data-testid="email-input-field" />

                        <label htmlFor="email" className="input-field-label" data-testid="email-input-label">
                          {t('EMAIL')}
                        </label>
                      </FloatLabel>
                    </div>

                    {userDetails.countryId === 102 && (
                      <>
                        <div className="dropdown-field-wrapper" data-testid="drop-down-field-wrapper">
                          <FloatLabel>
                            <Dropdown data-testid="drop-down-panel" id={'stateName'} options={stateList} value={selectedState} onChange={handleStateSelection} optionLabel="stateName" filter filterBy="stateName" className="state-selection-dropdown" panelClassName="state-select-dropdown-panel" />
                            <label htmlFor="stateName" className="input-field-label" data-testid="select-state-label">
                              {t('SELECT_STATE')}
                            </label>
                          </FloatLabel>
                        </div>
                        <div className="input-field">
                          <FloatLabel>
                            <InputText id="gstNumber" name="gstNumber" value={gstInput?.gstNumber} onChange={handleChange} className="p-inputtext-sm" autoComplete="off" data-testid="gst-number-input" />

                            <label htmlFor="gstNumber" className="input-field-label" data-testid="gst-number-label">
                              {t('GST_NO')}
                            </label>
                          </FloatLabel>
                        </div>
                      </>
                    )}
                    <div className="invoice-note" data-testid="invoice-note">
                      <span style={{ margin: '0px 10px' }}>{t('NOTE_INVOICE')}</span>
                    </div>

                    <Button buttonType="custom" buttonLabel={t('SAVE_DETAILS')} buttonWidth="full" buttonSize="small" buttonHover={true} onButtonClick={postGstDetailes} />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default ErrorMessageModal(PaymentGateway)
